import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

const apolloClient = new ApolloClient({
  link: createUploadLink({
    uri: location.protocol + '//' + location.host + '/x/api/platform/graphql',
    credentials: 'include'
  }),
  cache: new InMemoryCache({
    addTypename: false
  }),
  connectToDevTools: true
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      // fetchPolicy: 'cache-and-network',
    }
  }
})

export {
  apolloClient,
  apolloProvider
}
